import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SeedDataServiceService {

  constructor(private http: HttpClient) { }

  public seedData(seedDataByteArray: any): Observable<any> {
    const $this = this;

    let seedData = { Content: seedDataByteArray }

    return $this.http.post<any>(environment.apiUrl + 'api/v1/SeedData', seedData).pipe();
  }
}
